import { z } from 'zod'

/**
 * Predefined labels for evaluation criteria disputes.
 * These help categorize the reason for disputing a score.
 */
export const EvaluationCriteriaDisputeLabels = [
  'score_misapplied',
  'missing_context',
  'partial_credit',
  'tech_audio_issue',
  'other',
] as const

export type EvaluationCriteriaDisputeLabel =
  (typeof EvaluationCriteriaDisputeLabels)[number]

/**
 * Zod schema for validating dispute labels
 */
export const EvaluationCriteriaDisputeLabelSchema = z.enum(
  EvaluationCriteriaDisputeLabels,
)

/**
 * Human-readable labels for dispute reasons
 */
export const EvaluationCriteriaDisputeLabelDisplay: Record<
  EvaluationCriteriaDisputeLabel,
  string
> = {
  score_misapplied: 'Score misapplied',
  missing_context: 'Missing context',
  partial_credit: 'Partial credit',
  tech_audio_issue: 'Tech/audio issue',
  other: 'Other',
}

/**
 * Labels that require a note to be provided
 */
export const EvaluationCriteriaDisputeLabelsRequiringNote: EvaluationCriteriaDisputeLabel[] =
  ['other']
